export default __webpack_public_path__ + "assets/media/c41e3954a904694c558d51ae6132b9e1.mp3";